/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsTermsAndConditionsData } from './lds-terms-and-conditions.data';
import { ILdsTermsAndConditionsProps } from './lds-terms-and-conditions.props.autogenerated';

export interface ILdsTermsAndConditionsViewProps extends ILdsTermsAndConditionsProps<ILdsTermsAndConditionsData> {}

/**
 *
 * LdsFooter component
 * @extends {React.PureComponent<ILdsTermsAndConditionsProps<ILdsTermsAndConditions>>}
 */
class LdsTermsAndConditions extends React.PureComponent<ILdsTermsAndConditionsProps<ILdsTermsAndConditionsData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsTermsAndConditions;
